import { DrawerConstant } from '../constants'

const DrawerActions = {
  collapseDrawer,
  setCurrentChallenge,
  setAvailabilityObj,
  toggleMobileDrawer,
  exitVetsmith
};

function collapseDrawer (payload) {
  return {
    type: DrawerConstant.COLLAPSE_DRAWER,
    payload
  };
}

function setCurrentChallenge (payload) {
  return {
    type: DrawerConstant.SET_CURRENT_CHALLENGE,
    payload
  };
}

function setAvailabilityObj (payload) {
  return {
    type: DrawerConstant.SET_AVAILABILITY_OBJECT,
    payload
  }
}

function toggleMobileDrawer () {
  return {
    type: DrawerConstant.DRAWER_MOBILE_TOGGLE,
  };
}

function exitVetsmith(payload) {
  return {
    type: DrawerConstant.EXIT_VETSMITH,
    payload,
  }
}

export default DrawerActions
